import { AutogenLayoutLateRouteReport } from "./autogen/AutogenLayoutLateRouteReport";
import { ChangeEvent } from "@mcleod/components";

export class LateRouteReport extends AutogenLayoutLateRouteReport {
    override onLoad() {
        this.textboxGroupBy.setSelectedItemFromDisplayValue("Fleet");
    }

    /** This is an event handler for the onChange event of textboxGroupBy. */
    textboxGroupByOnChange(event: ChangeEvent) {
        if (event.domEvent != null && this.checkboxPageBreakGroupBy.checked) {
            if (this.textboxGroupBy.selectedItem.value === "fleet") {
                this.checkboxPageBreakAfterFleet.checked = true;
                this.checkboxPageBreakAfterUser.checked = false;
                this.checkboxPageBreakAfterDispatcher.checked = false;
            } else if (this.textboxGroupBy.selectedItem.value === "operations") {
                this.checkboxPageBreakAfterFleet.checked = false;
                this.checkboxPageBreakAfterUser.checked = true;
                this.checkboxPageBreakAfterDispatcher.checked = false;
            } else if (this.textboxGroupBy.selectedItem.value === "dispatcher") {
                this.checkboxPageBreakAfterFleet.checked = false;
                this.checkboxPageBreakAfterUser.checked = false;
                this.checkboxPageBreakAfterDispatcher.checked = true;   
            }
        }
    }

    /** This is an event handler for the onChange event of checkboxPageBreakGroupBy. */
    checkboxPageBreakGroupByOnChange(event: ChangeEvent) {
        if (event.domEvent != null) {
            if (this.checkboxPageBreakGroupBy.checked) {
                if (this.textboxGroupBy.selectedItem.value === "fleet") {
                    this.checkboxPageBreakAfterFleet.checked = true;
                    this.checkboxPageBreakAfterUser.checked = false;
                    this.checkboxPageBreakAfterDispatcher.checked = false;
                } else if (this.textboxGroupBy.selectedItem.value === "operations") {
                    this.checkboxPageBreakAfterFleet.checked = false;
                    this.checkboxPageBreakAfterUser.checked = true;
                    this.checkboxPageBreakAfterDispatcher.checked = false;
                } else if (this.textboxGroupBy.selectedItem.value === "dispatcher") {
                    this.checkboxPageBreakAfterFleet.checked = false;
                    this.checkboxPageBreakAfterUser.checked = false;
                    this.checkboxPageBreakAfterDispatcher.checked = true;
                }
            } else {
                this.checkboxPageBreakAfterFleet.checked = false;
                this.checkboxPageBreakAfterUser.checked = false;
                this.checkboxPageBreakAfterDispatcher.checked = false;
            }
        }
    }
}
